import * as React from "react";
import { DocumentPlusIcon, DocumentTextIcon } from "@heroicons/react/24/outline";
import { toDefaultDateFormat } from "@/helpers/dates";
import { Button } from "@/components/ui/button";
import { useToastDefault } from "@/hooks/use-toast-default";
import { Item } from "@/types/fse";
import { useLinkFileMutation } from "@/api/files";

interface Props {
  item: Item;
  currentFolderId: string;
}

export const AddFilesModalContentRow: React.FC<Props> = ({ item, currentFolderId }) => {
  const [isAdded, setIsAdded] = React.useState(false);
  const { showToast } = useToastDefault();

  const [linkFile] = useLinkFileMutation();

  const handleOnClick = async () => {
    await linkFile({ fse_id: currentFolderId, linked_fse_ids: [item.id] }).unwrap();
    setIsAdded(true);

    showToast("File Added", `${item.name} has been added successfully.`);
  };

  return (
    <div className="relative mb-1 flex flex-col items-start gap-4 border border-dotted border-custom-blue-100 p-4 md:flex-row md:items-center md:p-6">
      <div className="relative w-full md:w-1/2 lg:w-7/12">
        <div className="flex items-center">
          <DocumentTextIcon className="mr-2 h-5 w-5 text-blue-500" />
          <span className="truncate font-medium">{item.name}</span>
        </div>
        <div className="mt-1 flex flex-wrap items-center text-xs text-gray-500">
          <span className="mr-2">{toDefaultDateFormat(item.created_at)}</span>
        </div>
      </div>
      <div className="mt-2 flex w-full flex-wrap items-center justify-start gap-2 md:mt-0 md:w-1/2 md:justify-end lg:w-5/12">
        <Button
          variant="secondary"
          size="sm"
          className="w-full text-xs sm:w-auto"
          type="button"
          disabled={isAdded}
          onClick={handleOnClick}
        >
          <DocumentPlusIcon className="mr-1 h-4 w-4" />
          {isAdded ? "Added" : "Add file"}
        </Button>
      </div>
    </div>
  );
};
